export var conversationCellRenderer: agGrid.ICellRendererFunc = (params: any): HTMLElement | string => {
  if (params.data) {
    return `
<div class="media iio-resource-media">
    <div class="col-sm-2 text-left">
        <i class="fas fa-user-circle" style="color: lightgrey; font-size: 4vw"></i>
    </div>
    <div class="col-sm-8" style="overflow-x: hidden; text-overflow: ellipsis">
       <h5 ng-bind-html="data.participants | chatParticipants" style="overflow-x: hidden; text-overflow: ellipsis">
            Unknown
       </h5>
       <small ng-bind-html="data.mostRecentMessage.text" class="text-muted" ng-if="data.mostRecentMessage.text" style="margin-left: 1px; line-height: 1.4; white-space: normal; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical">
       </small>
       {{attachment}}
       <div ng-if="!data.mostRecentMessage.text" style="display: table-cell;" ng-repeat="attachment in data.mostRecentMessage.attachments">
          <img ng-if="attachment.imageType && !attachment.infected" ng-src="{{attachment.path}}" alt="" style="height:90px;object-fit: contain; object-position: left; margin-right: 15px; border-radius: 10px"/>
          <div ng-if="!attachment.imageType">
            <div>
                <i class="far fa-file fa-3x"></i>
            </div>
            <div>
                <small>{{attachment.fileName}}</small>
            </div>
          </div>
      </div>
    </div>
    <div class="col-sm-2 text-right" style="margin-left: -15px;">
       <small class="text-muted">
          {{ data.mostRecentMessage.formattedDateTimeSent }}
       </small>
    </div>
</div>`;
  }
};
